import {handleValidationChange} from '../CommonValidation';

export const validateRequest = (data, items, setIsError, type) => {
    //Required 
    // name: "",
    // list: false,
    // listInfo: false,
    // list must be equal or greater than one
    // all fields must be filled out in list

    var isValid = true;

    

    if(data.request_date === "") {
        handleValidationChange("request_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("request_date", false, setIsError);
    }

    if(data.request_number === "" || data.request_number === undefined || data.request_number === null) {
        handleValidationChange("request_number", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("request_number", false, setIsError);
    }

    if(data.branch_from === "" || data.branch_from === undefined) {
        handleValidationChange("branch_from", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_from", false, setIsError);
    }

    if(data.branch_to === "" || data.branch_to === undefined) {
        handleValidationChange("branch_to", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_to", false, setIsError);
    }

    if(data.delivery_date === "" || data.delivery_date === undefined) {
        handleValidationChange("delivery_date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("delivery_date", false, setIsError);
    }

    // if((data.dispatcher === "" || data.dispatcher === undefined || data.dispatcher === 0) && type === "edit" ) {
    //     handleValidationChange("dispatcher", true, setIsError);
    //     isValid=false;
    // } else {
    //     handleValidationChange("dispatcher", false, setIsError);
    // }

    if(items.length < 1) {
        handleValidationChange("list", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("list", false, setIsError);
    }

    items.map((data) => {
        if(data.item_id === "") {
            handleValidationChange("listInfo", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("listInfo", false, setIsError);
        }

        if(data.quantities === "") {
            handleValidationChange("listInfo", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("listInfo", false, setIsError);
        }
        
    })


    return isValid
  
}
